import confetti from 'canvas-confetti'

export function triggerSuccessConfetti () {
  const colors = ['#16a34a', '#2563EB', '#fbbf24']
  const burst = (origin) => confetti({
    particleCount: 80,
    spread: 70,
    startVelocity: 45,
    ticks: 200,
    colors,
    origin
  })
  setTimeout(() => {
    burst({ x: 0.2, y: 0.6 })
    burst({ x: 0.8, y: 0.6 })
  }, 250)
}



// WEBPACK FOOTER //
// ./src/utils/celebration.js